import React from "react";
import "./GroupListCard.scss";
import { IGroupListCardProps } from "./IGroupListCardProps";
import { Map } from "immutable";
import { push } from "connected-react-router";
import { withRouter } from "react-router";
import { connect } from "react-redux";
// import { GroupService } from "../../../api/services/groups";
import miscUtils from "../../../utils/miscUtils";
import ReadMore from "../../../utils/readMore/readMore";
// import appConfig from "appConfig";

const GroupCard: React.FC<IGroupListCardProps> = (props: any) => {

  function goToGroup() {
    window.location.assign(miscUtils.getRedirectBaseUrl(props.group))
  }

  const [isValidImage, setIsValidImage] = React.useState(true);
  const onImageError = (e: any) => {
    setIsValidImage(false)
  }

  return (
    <>
      {
        props.group &&
    <div className="card card-recommendation flex flex-justify-space-between dashboard-card">
      <div className="card-recommendation--content flex">
        <div className="card-recommendation--content-media">
              {props.group && props.group.unread_notifications ?
                <div className="dashbaord-group-notification-badge">
                    {
                            props.group.unread_notifications <= 9
                                ?
                                props.group.unread_notifications
                                :
                                '9+'
                    }
                </div> : <></>
            }
                {(props.group && props.group.profile_image && isValidImage) ? (
            <img
              src={props.group.profile_image}
              alt=""
              className={"card-recommendation--content-image"}
              onError={onImageError}
            />
          )
            : (
            <div
              className="group-name flex flex-justify-center flex-align-center"
              data-color={miscUtils.getColorInitial(`${props.group.name}`)}
            >
              {miscUtils.getNameInitials(props.group.name)}
            </div>
            )}
        </div>
        <div className="card-recommendation--content-page-info">
          <h3 onClick={() => goToGroup()}>{props.group.name}</h3>
          <span className="page--group-type">{props.group.status}</span>
          <div className="page--group-content group-description">
            {props.group  && props.group.description && props.group.description.length > 280 ? (
              <ReadMore
                text={props.group.description}
                numberOfLines={1}
                lineHeight={1}
                showLessButton={true}
                onContentChange={() => {}}
                className='page--group-content group-description'
              />
            ) : (
             props.group  && props.group.description
            )}
          </div>
          {/* <span className="page--member-count">
            {props.group.members_count} member
            {(props.group.members_count > 1 ||
              props.group.members_count === 0) &&
              "s"}
          </span> */}
        </div>
      </div>
      <div className="card-recommendation--action">
        <button
          className="btn btn-primary auto-height"
          onClick={() => {
            window.location.assign(miscUtils.getRedirectBaseUrl(props.group))
          }}
        >
          {/*{headerButtonLabel()}*/}
          Launch
          <img
            src={require("./arrow-right.svg")}
            alt=""
          />
        </button>
      </div>
    </div>
      }
    </>
  );
};

const mapStateToProps = (state: any, ownProps: IGroupListCardProps) => {
  const global = Map(state.get("global", {})).toJS() as any;
  const uid: string = state.getIn(["authorize", "uid"]) as string;
  return {
    global,
    uid
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: IGroupListCardProps) => {
  return {
    viewGroup: (groupSlug: any) => {
      dispatch(push(`/group/${groupSlug}`));
    }
    /*joinGroup: (userId: number, groupId: number) => {
      dispatch(groupActions.dbGroupJoin(userId, groupId));
    },
    leaveGroup: (userId: number, groupId: number) => {
      dispatch(groupActions.dbGroupLeave(userId, groupId));
    }*/
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroupCard as any) as any
) as any;
